// One message and one action, bottom centre (204). The studio had no toast:
// a refusal on credits is the first thing that has to be said on whatever
// bench the creator is standing on, with the one button that answers it.
export interface ToastState { text: string; action?: { label: string; onClick: () => void } }

export function Toast({ toast, onClose }: { toast: ToastState | null; onClose: () => void }) {
  if (!toast) return null;
  return (
    <div className="toast" role="status" data-tool="toast">
      <span>{toast.text}</span>
      {toast.action && <button type="button" className="btn pri tiny" onClick={() => { toast.action!.onClick(); onClose(); }}>{toast.action.label}</button>}
      <button type="button" className="btn tiny" aria-label="Dismiss" onClick={onClose}>×</button>
    </div>
  );
}
